import { 
  CQ_ACTION_CODES, 
  CQ_ACTION_NAME 
} from '../../../catalogConstants'
import { getPropKeyByValue } from '../../utils/common';
import { sendCustomTaggingWithParams } from '../../utils/taggingUtils';
import {
  GTM_PRODUCT_OFFERING_TEXT_EMPTY,
  GTM_PRODUCT_PROMOTION_TEXT_EMPTY,
  GTM_PRODUCT_OFFERING_ATTACHMENT_EMPTY,
} from './constants';

export const getCQActionNameByCode = (cqActionCode) => {
  const keyName = getPropKeyByValue(CQ_ACTION_CODES, cqActionCode);
  return CQ_ACTION_NAME[keyName] || '';
};

export const isNovum = () => {
  let res = false;
  if (typeof window !== 'undefined') {
    res = navigator.userAgent.toLowerCase().indexOf('novum') !== -1;
  }
  return res;
};
